import { createCustomIcon } from './utils/createCustomIcon';

const LockKeyholeIcon = createCustomIcon({
  displayName: 'LockKeyholeIcon',
  defaultFill: 'currentColor',
  children: (
    <path d="M12 1.5C13.4587 1.5 14.8572 2.07988 15.8887 3.11133C16.9201 4.14278 17.5 5.54131 17.5 7V9.5H19C20.3807 9.5 21.5 10.6193 21.5 12V20C21.5 21.3807 20.3807 22.5 19 22.5H5C3.61929 22.5 2.5 21.3807 2.5 20V12C2.5 10.6193 3.61929 9.5 5 9.5H6.5V7C6.5 5.54131 7.07988 4.14278 8.11133 3.11133C9.14278 2.07988 10.5413 1.5 12 1.5ZM12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14ZM12 2.5C10.8065 2.5 9.66227 2.97445 8.81836 3.81836C7.97445 4.66227 7.5 5.80653 7.5 7V9.5H16.5V7C16.5 5.80653 16.0256 4.66227 15.1816 3.81836C14.3377 2.97445 13.1935 2.5 12 2.5Z" />
  ),
});

export default LockKeyholeIcon;
